import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { useTheme } from "@mui/material";
import React from "react";

import { TooltipIconButton } from "@/shared/components";
import { IngestionStatus } from "@/shared/domain/files/FileRecord";
import {
  isFile,
  FileSystemNode,
} from "@/shared/domain/files/filesystem/fileSystemNode";
import { canHaveTopics } from "@/shared/domain/files/fileTypes";

import { RowTypeIcon } from "./RowTypeIcon";

interface ExpandRowIconProps {
  isExpanderOpen: boolean;
  row: FileSystemNode;
  handleIconClick: () => void;
}

export const ExpandRowIcon: React.FC<ExpandRowIconProps> = ({
  isExpanderOpen,
  row,
  handleIconClick,
}) => {
  const theme = useTheme();

  const isIngestedFile =
    isFile(row) && row.file.ingestion_status !== IngestionStatus.NotIngested;

  const isRoboticsFile = canHaveTopics(row.name);

  if (!isRoboticsFile && !isIngestedFile) {
    return <RowTypeIcon rowName={row.name} rowType={row.type} />;
  }

  let title;
  if (isIngestedFile) {
    title = isExpanderOpen ? "Hide Details" : "Show Details";
  } else {
    title = "Not Ingested";
  }

  return (
    <TooltipIconButton
      title={title}
      onClick={handleIconClick}
      disabled={!isIngestedFile}
      sx={{
        padding: theme.spacing(0.25),
        transform: isExpanderOpen ? "none" : "rotate(270deg)",
      }}
    >
      <ExpandCircleDownOutlinedIcon
        color={isIngestedFile ? "primary" : "disabled"}
        fontSize="small"
      />
    </TooltipIconButton>
  );
};
